import { RuleOutcome } from './vocabulary.ts'

/** What the verification recorded about one rule. Mirrors `WireRuleOutcome`. */
export interface RuleOutcomeRecord {
  rule: string
  /** The rule's title when it ran, which may no longer be today's. */
  title: string
  severity: 'error' | 'reminder'
  outcome: RuleOutcome
  sequences?: number[]
  /** The preparations it fired for, in the screen's ids. */
  preparationIds?: string[]
  /** It raised something about the requisition as a whole. */
  requisitionWide?: boolean
  error?: string
}

/** One rule as one formula's block shows it. */
export interface RuleOutcomeLine {
  rule: string
  title: string
  severity: 'error' | 'reminder'
  outcome: RuleOutcome
  /** Fired about the requisition rather than about this formula. */
  requisitionWide: boolean
  error?: string
}

/**
 * The recorded outcomes as they read on one formula.
 *
 * A rule is recorded once for the whole requisição; a formula shows it as
 * fired only where it fired. On the others it raised nothing, which is all
 * "sem apontamento" says. A finding about the whole requisição concerns every
 * formula, so it shows on each.
 */
export function ruleOutcomesFor(
  outcomes: readonly RuleOutcomeRecord[],
  preparationId: string,
): RuleOutcomeLine[] {
  return outcomes.map((one) => {
    const here = one.preparationIds?.includes(preparationId) === true
    const wide = one.requisitionWide === true
    const outcome =
      one.outcome === RuleOutcome.Fired && !here && !wide ? RuleOutcome.Passed : one.outcome
    return {
      rule: one.rule,
      title: one.title,
      severity: one.severity,
      outcome,
      requisitionWide: outcome === RuleOutcome.Fired && wide && !here,
      ...(one.error === undefined ? {} : { error: one.error }),
    }
  })
}
